/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from '../BusinessVehicleInformation.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { changeObjectPropertyAction, listDeleteAction } from 'redux/actions'

const BusinessVehicleListTable = ({ t, i18n, setIsError, reviewConfirmation = false, isSummary = false }) => {
    let history = useHistory()
    const dispatch = useDispatch()

    const businessVehicles = useSelector((state) => state.app.businessVehicleInformation.businessVehicles)
    useEffect(() => {
        try {
            if (!isSummary && businessVehicles.length === 0) {
                dispatch(changeObjectPropertyAction('businessVehicleInformation', 'editMasterNumber', ''));
                history.push(`/${i18n.language}${t('routes.business_vehicle_info')}`)
            }
            // vehicle.map((householdMember) => {
            //   if (!isValidPermit(householdMember)) {
            //     // TODO: HOOKUP
            //     // dispatch(listDeleteAction(householdMember.plateNumber))
            //   }
            // })
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }, [businessVehicles, history, i18n.language, isSummary, setIsError, t, dispatch])



    return (
        <div className="row">
            <div className="col-xs-12 col-lg-8">
                <div className={styles['overflow_mobile']}>
                    {/* <table className={['table', styles['border_none']].join(' ')} style={{ marginBottom: '0px' }}> */}
                    {businessVehicles.map((businessVehicle, i) => {
                        return <VehicleRow key={i} islast={i === businessVehicles.length - 1} vehicle={businessVehicle} t={t} i18n={i18n} setIsError={setIsError} reviewConfirmation={reviewConfirmation} isSummary={isSummary} />
                    })}
                    {/* </table> */}
                </div>
            </div>
        </div>
    )
}

const VehicleRow = ({ vehicle, i18n, t, setIsError, reviewConfirmation, isSummary, isLast }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    // const permitEl = useRef(null)

    const editVehicleOnClick = () => {
        try {

            const { masterNumber } = vehicle;
            dispatch(changeObjectPropertyAction('businessVehicleInformation', 'editMasterNumber', masterNumber));
            dispatch(changeObjectPropertyAction('businessVehicleInformation', 'businessName', vehicle.businessName));
            dispatch(changeObjectPropertyAction('businessVehicleInformation', 'masterNumber', vehicle.masterNumber));
            // if (reviewConfirmation) {
            //     // TODO: HOOKUP
            //     // dispatch(editFromConfirmationAction(true));
            // }
            history.push(`/${i18n.language}${t('routes.business_vehicle_info')}?isSummary=${isSummary}`)
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    const removeVehicleOnClick = () => {
        try {
            const { masterNumber } = vehicle
            dispatch(listDeleteAction("businessVehicleInformation", masterNumber))
            if (reviewConfirmation) {
                // history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
            }
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    // const dashIfNull = (data) => {
    //     return data ? data : '-'
    // }

    const popUpBox = () => {
        let confirmText = window.confirm(`${t('are_you_sure')}`)
        if (confirmText == true) {
            //   console.log('hit true')
            removeVehicleOnClick();
        }
        // else {
        //   console.log("do nothing")
        // }
    }

    return (

        <div className="row">
            <div className="col-xs-12 col-lg-12">
                <div className="col-xs-12">
                    <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
                        <div style={{ display: "flex", flexGrow: 1, justifyContent: "space-between", alignItems: "center" }}>
                            <div className="col-xs-6">
                                <h3>{t('review_summary.business_vehicle')}</h3>
                                <br></br>

                            </div>
                            <div className="col-xs-6">

                                <a href="#" className={[styles['edit_button']].join(' ')}
                                    onClick={editVehicleOnClick}
                                    value={t('business_vehicle_info_summary.edit')} name={t('business_vehicle_info_summary.edit')}>
                                    {t('business_vehicle_info_summary.edit')}
                                </a>
                                {!isSummary && (
                                    <a
                                        href={reviewConfirmation ? `/${i18n.language}${t('routes.review_confirmation')}` : `/${i18n.language}${t('routes.business_vehicle_info_summary')}`}
                                        onClick={popUpBox}
                                        value={' ' + t('business_vehicle_info_summary.remove')}
                                        name={' ' + t('business_vehicle_info_summary.remove')}
                                    >
                                        {' ' + t('business_vehicle_info_summary.remove')}
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>


                    <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                        <div className="col-xs-6"><strong>{t('business_vehicle_info_summary.name')}</strong></div>
                        <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{vehicle.businessName}</div>
                    </div>
                    <hr />


                    <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                        <div className="col-xs-6"><strong>{t('business_vehicle_info_summary.master_number')}</strong></div>
                        <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{vehicle.masterNumber.toUpperCase()}</div>
                    </div>

                    <hr />
                </div>
            </div>
        </div>

        // <div className="col-xs-12" style={{ border: '1px solid black', marginBottom: isLast ? 0 : "1rem" }}>
        //     <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
        //         <div style={{ flexGrow: 1 }}>
        //             {isSummary && (
        //                 <div className="col">
        //                     <h2>{t('review_summary.business_vehicle')}</h2>
        //                 </div>
        //             )}
        //         </div>
        //     </div >
        //     <div className={"row " + styles['table-row']} style={{ display: 'flex', flexGrow: 1, }}>
        //         <div className="col"><strong>{t('business_vehicle_info_summary.name')}</strong></div>
        //         <div className="col">{vehicle.businessName}</div>
        //         <div className={"col " + styles['actions_column']} >
        //             <a
        //                 href="#"
        //                 className={[styles['edit-button']].join(' ')}
        //                 onClick={editVehicleOnClick}
        //                 value={t('business_vehicle_info_summary.edit')}
        //                 name={t('business_vehicle_info_summary.edit')}
        //             >
        //                 {t('business_vehicle_info_summary.edit')}
        //             </a>
        //             {!isSummary && (
        //                 <a
        //                     href={reviewConfirmation ? `/${i18n.language}${t('routes.review_confirmation')}` : `/${i18n.language}${t('routes.business_vehicle_info_summary')}`}
        //                     className={styles['remove_button']}
        //                     onClick={removeVehicleOnClick}
        //                     value={t('business_vehicle_info_summary.remove')}
        //                     name={t('business_vehicle_info_summary.remove')}
        //                 >
        //                     {t('business_vehicle_info_summary.remove')}
        //                 </a>
        //             )}
        //         </div>

        //     </div>
        //     <div className={"row " + styles['table-row']} style={{ display: 'flex', flexGrow: 1, }}>
        //         <div className="col"><strong>{t('business_vehicle_info_summary.master_number')}</strong></div>
        //         <div className={"col " + styles['line-break']}>{vehicle.masterNumber.toUpperCase()}</div>
        //         <div className={"col " + styles['actions_column']} />
        //     </div>

        // </div>


    )
}

export default withTranslation('common')(BusinessVehicleListTable)
